import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/ins-market`;
const ADMIN = `${process.env.REACT_APP_BACKEND_URL}/api/admin/ins-market`;
export const INS_TOKEN_KEY = "wz_ins_token";
const prov = axios.create({ baseURL: `${API}/provider`, withCredentials: true });
prov.interceptors.request.use((c) => {
  const t = localStorage.getItem(INS_TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
const d = (r) => r.data;

export const insApi = {
  candidates: (kind) => axios.get(`${API}/candidates`, { params: { kind } }).then(d),
  createRequest: (body) => axios.post(`${API}/requests`, body).then(d),
  requests: (kind) => axios.get(`${API}/requests`, { params: { kind } }).then(d),
  accept: (qid) => axios.post(`${API}/quotes/${qid}/accept`).then(d),
  cancel: (rid) => axios.post(`${API}/requests/${rid}/cancel`).then(d),
  register: (body) => prov.post("/register", body).then(d),
  login: (body) => prov.post("/login", body).then((r) => { localStorage.setItem(INS_TOKEN_KEY, r.data.token); return r.data; }),
  logout: () => prov.post("/logout").finally(() => localStorage.removeItem(INS_TOKEN_KEY)),
  dashboard: () => prov.get("/dashboard").then(d),
  setKinds: (kinds) => prov.put("/kinds", { kinds }).then(d),
  quote: (rid, body) => prov.post(`/requests/${rid}/quote`, body).then(d),
  issue: (qid, body) => prov.post(`/quotes/${qid}/issue`, body).then(d),
  rate: (qid, body) => axios.post(`${API}/quotes/${qid}/rate`, body).then(d),
  borderPending: () => axios.get(`${API}/border-pending`).then(d),
  borderToIqama: (eid, body) => axios.post(`${API}/border-employee/${eid}/iqama`, body).then(d),
  borderEmployee: (body) => axios.post(`${API}/border-employee`, body).then(d),
  adminInvoices: () => axios.get(`${ADMIN}/invoices`).then(d),
  adminGenInvoices: (period) => axios.post(`${ADMIN}/invoices/generate`, { period }).then(d),
  adminPayment: (iid, body) => axios.post(`${ADMIN}/invoices/${iid}/payment`, body).then(d),
  adminProviders: () => axios.get(`${ADMIN}/providers`).then(d),
  adminUpdate: (pid, body) => axios.put(`${ADMIN}/providers/${pid}`, body).then(d),
  adminRequests: (status) => axios.get(`${ADMIN}/requests`, { params: { status } }).then(d),
  forgot: (email) => prov.post("/forgot", { email }).then(d),
  reset: (body) => prov.post("/reset", body).then(d),
};

export const errMsg = (e, f = "حدث خطأ") => {
  const x = e?.response?.data?.detail;
  if (typeof x === "string") return x;
  if (Array.isArray(x)) return x.map((i) => i?.msg).filter(Boolean).join(" ") || f;
  return f;
};
export const sar = (n) => `${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 2 })} ر.س`;
export const KIND_LABEL = { individuals: "تأمين طبي للأفراد", cars: "تأمين سيارات", moto: "تأمين دراجات نارية", medical: "فحوص طبية" };
export const EXAM_LABEL = { iqama: "فحص إصدار إقامة", license: "فحص إصدار رخص قيادة", health_cert: "إصدار شهادة صحية لتوصيل الطلبات" };
export const kindText = (r) => KIND_LABEL[r.kind] + ((r.exam_types || []).length ? ` (${r.exam_types.map((x) => EXAM_LABEL[x]).join("، ")})` : "");
